import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField,
	MuiThemeProvider,
	createMuiTheme,
  Checkbox,
  FormControlLabel,
  Tooltip
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteMedia, getMediaById, postMedia, updateMedia } from '../../../../api/media'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog"
import PreviewDialog from "../../../components/dialogs/PreviewDialog"
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { SERVER_URL } from "../../../../api"
import { alertError, alertSuccess } from '../../../../utils/logger'
import { buttonsStyle } from '../../../components/tables/table'
import { ArrowUpward, ArrowDownward, Visibility } from '@material-ui/icons'
import DeleteIcon from '@material-ui/icons/Delete'
import Editor from '../../../components/editor/Editor'

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: '#F64E60'
		}
  }
})

function getEmptyMedia() {
  return {
    title: {},
    subtitle: {},
    filesURLs: [],
    active: true
  }
}

export default function EditMediaPage() {
  const [media, setMedia] = useState(getEmptyMedia())
	const [selectedFiles, setSelectedFiles] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [openPreviewDialog, setOpenPreviewDialog] = useState(null)
  const mediaId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!mediaId) {
      disableLoadingData()
      return
    }
    getMediaById(mediaId).then(res => {
      if (res.status === 200) {
        setMedia(res.data)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get media.' })
      history.push('/media')
    })
  }, [mediaId, disableLoadingData, history])

  function saveMedia() {
    if (!mediaId) {
      postMedia(media, selectedFiles).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: 'Saved!', customMessage: 'Media saved successfully.' })
          history.push('/media')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save media.' })
      })
    } else {
      updateMedia(mediaId, media, selectedFiles).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
          history.push('/media')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === ' ') return
      if (!media[element]) media[element] = {}
      let newText = media[element]
      newText[lang] = event.target.value
      setMedia({ ...media, [element]: newText })
    } else setMedia({ ...media, [element]: event.target.value })
  }

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === ' ') return
      if (!media[element]) media[element] = {}
      let newText = media[element]
      newText[lang] = value
      setMedia({ ...media, [element]: newText })
    } else setMedia({ ...media, [element]: value })
  }

  const handleDeleteFile = (index) => {
    // TODO: DELETE FILES FROM SERVER
    let newFiles = [...media.filesURLs]
    /*const deletedFile =*/ newFiles.splice(index, 1)
    setMedia({ ...media, filesURLs: newFiles })
    if (selectedFiles && selectedFiles[index]) {
      let _selectedFiles = {}
      for (const [key, value] of Object.entries(selectedFiles)) {
        if (key !== index) {
          if (key > index) {
            _selectedFiles[key - 1] = value
          } else _selectedFiles[key] = value
        } 
      }
      if (!Object.keys(_selectedFiles).length) _selectedFiles = null
      setSelectedFiles(_selectedFiles)
    } /*else setDeletedFiles(deletedFiles ? deletedFiles.concat(deletedFile) : [deletedFile])*/
  }

  const handleMoveFile = (index, newIndex) => {
    const aux = media.filesURLs[index]
    let files = [...media.filesURLs]
    files.splice(index, 1, files[newIndex])
    files.splice(newIndex, 1, aux)
    setMedia({ ...media, filesURLs: files })
    if (selectedFiles && (selectedFiles[index] || selectedFiles[newIndex])) {
      let _selectedFiles = {}
      for (const [key, value] of Object.entries(selectedFiles)) {
        if (key === index.toString()) _selectedFiles[newIndex] = value
        else if (key === newIndex.toString()) _selectedFiles[index] = value
        else _selectedFiles[key] = value
      }
      setSelectedFiles(_selectedFiles)
    }
  }

  const renderMultilanguageTabContent = lang => {
    return (
      <>
        <TextField
          id={`title`}
					label="Title"
          value={(media.title && media.title[lang]) || ''}
          onChange={handleChange('title', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
          required
        />
				<TextField
					id={`subtitle`}
					label="Subtitle"
					value={(media.subtitle && media.subtitle[lang]) || ''}
					onChange={handleChange('subtitle', lang)}
					InputLabelProps={{
						shrink: true
					}}
					margin="normal"
					variant="outlined"
				/>
      </>
    )
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Edit media'>
        </CardHeader>
        <CardBody>
          <MultilanguageTabBlock
						multilanguageTabContent = {renderMultilanguageTabContent}
					/>
        </CardBody>
        <CardBody>
          {media.filesURLs?.map((_, index) => {
            return (
              <>
                <label htmlFor={"upload-file" + index}>
                  <input
                    style={{ display: 'none' }}
                    id={"upload-file" + index}
                    name={"upload-file" + index}
                    type="file"
                    onChange={(e) => {
                      setSelectedFiles({ ...selectedFiles, [index]: e.target.files[0] })
                    }}
                  />
                  <Button
                    style={{ marginRight: '15px' }}
                    color="secondary"
                    component="span"
                    variant="outlined">
                    {((selectedFiles && selectedFiles[index]) || media.filesURLs[index] !== '') ? 'Change file ' + (index + 1) : 'Upload file ' + (index + 1)}
                  </Button>
                </label>
                {((selectedFiles && selectedFiles[index]) || media.filesURLs[index] !== '') &&
                  <>
                    <Tooltip title={'Preview file ' + (index + 1)}>
                      <Button
                        size="small"
                        onClick={() => setOpenPreviewDialog(index)}
                        style={buttonsStyle}>
                        <Visibility/>
                      </Button>
                    </Tooltip>
                    <PreviewDialog
                      title={'Preview file ' + (index + 1)}
                      open={openPreviewDialog === index}
                      setOpen={setOpenPreviewDialog}
                      src={(selectedFiles && selectedFiles[index]) ? URL.createObjectURL(selectedFiles[index]) : `${SERVER_URL}/${media.filesURLs[index]}`}
                    />
                    <Tooltip title="Delete">
                      <Button
                        size="small"
                        style={buttonsStyle}
                        onClick={() => handleDeleteFile(index)}>
                        <DeleteIcon/>
                      </Button>
                    </Tooltip>
                    <Tooltip title="Move up">
                      <Button
                        size="small"
                        style={buttonsStyle}
                        disabled={index === 0}
                        onClick={() => handleMoveFile(index, index - 1)}>
                        <ArrowUpward/>
                      </Button>
                    </Tooltip>
                    <Tooltip title="Move down">
                      <Button
                        size="small"
                        disabled={!(index < media.filesURLs.length - 1 && ((selectedFiles && selectedFiles[index + 1]) || media.filesURLs[index + 1] !== ''))}
                        style={{...buttonsStyle, marginRight: '1em' }}
                        onClick={() => handleMoveFile(index, index + 1)}>
                        <ArrowDownward/>
                      </Button>
                    </Tooltip>
                    <span>
                      {selectedFiles && selectedFiles[index] ? selectedFiles[index]?.name : (media.filesURLs[index] !== '' ? media.filesURLs[index].split(/-(.*)/s)[1] : '')}
                    </span>
                    <br />
                  </>
                }
              </>
            )
          })}
          <br />
          <br />
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setMedia({ ...media, filesURLs: media.filesURLs.concat('') })}
          >
            Add file
          </Button>
          <br />
          <br />
          <FormControlLabel
            control={<Checkbox checked={media.active} onChange={() => setMedia({ ...media, active: !media.active })} name="checkActive" />}
            label="Active"
          />
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/media')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>
      <Button
        onClick={() => saveMedia()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Save media
      </Button>
      {mediaId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Delete media
          </Button>
        </MuiThemeProvider>
      </>}
      <ConfirmDialog
        title={'Are you sure you want to delete this media?'}
        open={openConfirmDialog}
        setOpen={setOpenConfirmDialog}
        onConfirm={() => {
          deleteMedia(mediaId).then(res => {
            if (res.status === 204 || res.status === 200) {
              alertSuccess({ title: 'Deleted!', customMessage: 'Media deleted successfully' })
              history.push('/media')
            }
          }).catch(error => {
            alertError({ error: error, customMessage: 'Could not delete media.' })
          })
        }}
      />
    </>
  );
}
